module.exports = __webpack_public_path__ + "static/couatl-5680b49caadaac56ff157c370f04a787.jpg";